import React from 'react'
import { TemplateContainer } from '../../containers/dashboard/template'

export default function BulkAddUsers({accessToken, name, email, isActive, isSuperuser}) {
    return (
    <TemplateContainer pageName={'Add a new user'} email={email} 
    name={name} 
    accessToken={accessToken}
    isActive={isActive}
    isSuperuser={isSuperuser}
    />)
}

